import { ProfileCircleIcon } from '@/common/icons/general.tsx'
import { IconType } from '@/common/icons/types.ts'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const avatarVariants = cva(
  'w-10 h-10 flex items-center justify-center rounded-full text-sm font-medium',
  {
    variants: {
      variant: {
        default: 'bg-primary-100 text-primary-900',
        neutral: 'bg-gray-100 border border-gray-200 text-gray-700',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

interface IDefaultAvatar extends VariantProps<typeof avatarVariants> {
  firstName?: string | null
  lastName?: string | null
  className?: string
  containerClassName?: string
}

export const DefaultAvatar = ({
  firstName,
  lastName,
  variant,
  className,
  containerClassName,
}: IDefaultAvatar) => {
  const getInitials = (firstName?: string | null, lastName?: string | null) => {
    return `${firstName?.substring(0, 1) ?? ''}${lastName?.substring(0, 1) ?? ''}`
  }

  return (
    <div
      className={cn('text-sm font-medium text-gray-900 ', containerClassName)}
    >
      <div className={cn(avatarVariants({ variant }), className)}>
        {getInitials(firstName, lastName)}

        {!firstName && !lastName && (
          <ProfileCircleIcon
            className={cn(
              'text-lg group-hover:text-primary',
              variant === 'neutral' ? 'text-gray-500' : 'text-gray-500'
            )}
            type={IconType.Outline}
          />
        )}
      </div>
    </div>
  )
}

export default DefaultAvatar
